<!--
 * @Description: 数字问卷 21
 * @Date: 2022-06-27 10:50:51
-->
<template>
  <div class>
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="210px"
      class="ruleForm"
    >
      <submit-result
        :auditList="addEditMixin_auditList"
        :projectStatus="ruleForm.projectStatus"
      ></submit-result>
      <div class="xrk-project-form">
        <div class="left">
          <div>
            <xrk-subtitle>项目信息</xrk-subtitle>
            <el-form-item label="项目编码：" prop="projectName">
              <el-input v-model.trim="ruleForm.projectNo" disabled></el-input>
              <el-button
                type="primary"
                class="copyBtn_1"
                :data-clipboard-text="ruleForm.projectNo"
                @click="$copy('copyBtn_1')"
              >
                复制
              </el-button>
            </el-form-item>
            <el-form-item
              label="客户企业："
              prop="enterpriseId"
              v-if="hasIndustry || penetratingDisplay != -1"
            >
              <el-tooltip
                effect="dark"
                :content="ruleForm.industryEnterpriseName"
                placement="top"
              >
                <el-input
                  disabled
                  :value="ruleForm.industryEnterpriseName"
                  v-if="hasIndustry || penetratingDisplay != -1"
                ></el-input>
              </el-tooltip>
            </el-form-item>
            <el-form-item label="项目名称：" prop="projectName">
              <el-input disabled v-model.trim="ruleForm.projectName"></el-input>
            </el-form-item>
            <el-form-item
              label="项目简介："
              prop="introduction"
              class="absoluteBox"
            >
              <el-input
                :class="{
                  redText:
                    !(ruleForm.industryEnterpriseId > 0) &&
                    !addEditMixin_introductionDisbaled
                }"
                type="textarea"
                v-model.trim="ruleForm.introduction"
                placeholder="请输入项目简介"
                :rows="7"
                style="width:300px;"
                maxlength="200"
                :show-word-limit="true"
                :disabled="addEditMixin_introductionDisbaled"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="项目结算单价（不含税）："
              v-if="hasIndustry"
              prop="price"
            >
              <el-input
                :disabled="!canSubmit"
                v-model="ruleForm.price"
              ></el-input>
              <span style="margin-left:10px;">元</span>
            </el-form-item>
            <el-form-item label="终端结算单价：" prop="csoPrice">
              <el-input
                :disabled="!canSubmit"
                v-model.trim="ruleForm.csoPrice"
                :maxlength="11"
              ></el-input>
              <span style="margin-left:10px;">元</span>
            </el-form-item>
            <el-form-item
              label="税率："
              v-if="hasIndustry"
              prop="contractScale"
            >
              <el-input
                :disabled="!canSubmit"
                v-model.trim="ruleForm.contractScale"
              ></el-input>
              <span style="margin-left:10px;">%</span>
              <!-- {{ ruleForm.contractScale | transScale }} -->
            </el-form-item>
            <el-form-item label="总任务量：" prop="taskSumCount">
              <el-input disabled :value="ruleForm.taskSumCount || 0"></el-input>
            </el-form-item>
            <el-form-item label="已完成任务量：">
              <el-input
                disabled
                :value="ruleForm.finishSumCount || 0"
              ></el-input>
            </el-form-item>
            <!-- 项目支付通道 -->
            <pay-channel />
          </div>
          <div style="margin-top:50px">
            <xrk-subtitle>
              项目执行要求
            </xrk-subtitle>

            <el-form-item label="背景需求：" prop="projectBackground">
              <el-select
                v-model="ruleForm.projectBackground"
                :disabled="!canSubmit"
                placeholder="请选择背景"
                @change="addEditMixin_validateBackground"
              >
                <el-option
                  v-for="item in addEditMixin_backgroundList"
                  :key="item.id"
                  :value="item.id"
                  :label="item.label"
                ></el-option>
              </el-select>
            </el-form-item>

            <!--1 项目执行人脱敏规则：-->
            <tm-execute-name-rule
              v-model="ruleForm.tmExecuteNameRule"
              :disabled="addEditMixin_disbaled"
            />
            <el-form-item
              v-for="(ele, i) in addEditMixin_formItems"
              :label="ele.label"
              :key="i"
              :prop="ele.prop"
              :rules="ele.rule"
            >
              <el-input
                v-model="ruleForm[ele.prop]"
                :disabled="!canSubmit"
                v-bind="ele"
              >
                <template #append>
                  {{ ele.suffix }}
                  <el-tooltip placement="top" effect="light">
                    <div slot="content" v-html="ele.content"></div>
                    <i class="el-icon-question"></i>
                  </el-tooltip>
                </template>
              </el-input>
            </el-form-item>

            <el-form-item label="职业认证：" prop="isOccupationAuth">
              <el-radio-group
                v-model="ruleForm.isOccupationAuth"
                :disabled="!canSubmit"
              >
                <el-radio
                  border
                  class="auth-type"
                  :label="item.type"
                  v-for="(item, index) in isOccupationAuthArray"
                  :key="`way${index}`"
                >
                  {{ item.value }}
                </el-radio>
              </el-radio-group>
            </el-form-item>
            <template v-if="ruleForm.isOccupationAuth">
              <el-form-item label="认证类型：" prop="occupationType">
                <!-- <span>认证类型：</span> -->
                <span>
                  <el-select
                    v-model="ruleForm.occupationType"
                    :disabled="addEditMixin_disbaled"
                    placeholder="请选择认证类型"
                  >
                    <el-option
                      v-for="item in occupationTypeArray"
                      :key="item.id"
                      :value="item.id"
                      :label="item.label"
                    ></el-option>
                  </el-select>
                </span>
              </el-form-item>
              <el-form-item label="认证方式：" prop="occupationAuthMode">
                <el-radio-group
                  v-model="ruleForm.occupationAuthMode"
                  :disabled="addEditMixin_disbaled"
                >
                  <el-radio
                    border
                    :label="item.type"
                    v-for="(item, index) in occupationAuthModeArray"
                    :key="`way${index}`"
                  >
                    {{ item.value }}
                  </el-radio>
                </el-radio-group>
              </el-form-item>
            </template>
            <el-form-item
              label="C端图片查重："
              v-if="addEditMixin_repeatFormItemEnabled"
              prop="isCPicRepeat"
            >
              <el-radio-group
                v-model="ruleForm.isCPicRepeat"
                :disabled="!canSubmit"
              >
                <el-radio border class="auth-type" :label="1">
                  是
                </el-radio>
                <el-radio border class="auth-type" :label="0">
                  否
                </el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item
              label="订单支付审核："
              v-if="ruleForm.isOrderAudit == 1"
            >
              <el-button
                plain
                style="color: #3a8ee6;border-color: #3a8ee6;cursor: default;"
              >
                需审核
              </el-button>
              <span>
                项目支付给自然人时需进行审核
              </span>
            </el-form-item>
            <el-form-item label="是否需要执行人上传资质证明：">
              <el-radio
                :disabled="addEditMixin_disbaled"
                v-model="ruleForm.isNeedCertification"
                :label="1"
              >
                需要
              </el-radio>
              <el-radio
                :disabled="addEditMixin_disbaled"
                v-model="ruleForm.isNeedCertification"
                :label="0"
              >
                不需要
              </el-radio>
            </el-form-item>
            <updateQualificationProof
              :disabled="addEditMixin_disbaled"
              v-model="ruleForm.certificationClassifyList"
              @selectOptionsDataEvent="selectOptionsDataEvent"
              v-if="ruleForm.isNeedCertification === 1"
            ></updateQualificationProof>
          </div>
        </div>

        <div class="right">
          <xrk-subtitle>需求信息</xrk-subtitle>
          <el-form-item label="封面图：" prop="bgUrl">
            <!-- disabled条件与其他场景不一样 -->
            <GenerateImage
              :initUrl="ruleForm.bgUrl"
              :oldUrl="ruleForm.oldBgUrl"
              :initType="ruleForm.bgUrlSource"
              @done="addEditMixin_finishUpload"
              @finish="addEditMixin_finishUpload"
              @changeType="addEditMixin_changeBgType"
              :auditStatus="ruleForm.auditStatus"
              :disabled="!canSubmit"
            ></GenerateImage>
          </el-form-item>
          <el-form-item label="答题方式：" prop="answerMode">
            <el-radio-group v-model="ruleForm.answerMode" disabled>
              <el-radio
                border
                class="auth-type"
                :label="item.type"
                v-for="(item, index) in addEditMixin_answerModeOptions"
                :key="`way${index}`"
              >
                {{ item.value }}
              </el-radio>
            </el-radio-group>
          </el-form-item>
        </div>
      </div>
      <div class="xrk-project-footer">
        <template v-if="addEditMixin_showSaveBtn">
          <el-button
            type="primary"
            plain
            @click="addEditMixin_submitForm('ruleForm')"
            :loading="btLoading"
            :disabled="!canSubmit"
          >
            保存
          </el-button>
          <submit-verify-btn
            @finish="addEditMixin_finishSubmit"
            :auditStatus="ruleForm.auditStatus"
            :ifDis="!canSubmit"
          ></submit-verify-btn>
        </template>
        <el-button
          type="primary"
          plain
          v-if="addEditMixin_showAginEditBtn"
          @click="addEditMixin_onAginEditProject(ruleForm)"
          :loading="btLoading"
          :disabled="addEditMixin_aginEditBtnDisabled"
        >
          再次编辑
        </el-button>
        <template v-if="addEditMixin_showAginSaveBtn">
          <el-button
            type="primary"
            plain
            @click="addEditMixin_cancelEditProject('ruleForm')"
          >
            取消
          </el-button>
          <el-button
            type="primary"
            plain
            @click="addEditMixin_confirmEditProject('ruleForm')"
            :loading="btLoading"
          >
            提交审核
          </el-button>
        </template>
        <submit-verify-and-next-btn
          :info="ruleForm"
          :submitFn="addEditMixin_finishSubmit"
        ></submit-verify-and-next-btn>
      </div>
    </el-form>
  </div>
</template>
<script>
import { selectChannel, projectV2 } from '@/api/ajax';
import addEdit from '@/page/project-classify/src/mixins/add-edit';
import updateQualificationProof from '../../../update-qualification-proof/update-qualification-proof';
export default {
  name: 'digitalSurvey',
  mixins: [addEdit],
  components: { updateQualificationProof },
  data() {
    return {
      searchAjax: selectChannel,
      defaultObj: {
        title: '',
        id: ''
      },
      prop: {
        label: 'title',
        code: 'id'
      },

      channel: {},
      ruleForm: {
        channelId: '',
        channelEditorType: 1
      },

      // 校验
      rules: {},

      hasAnswerModeAndChannelName: false
    };
  },

  computed: {
    canSubmit() {
      return !this.addEditMixin_disbaled && this.hasAnswerModeAndChannelName;
    }
  },
  async created() {
    const data = await this.addEditMixin_init();
    if (this.$route.query.id) {
      // 获得 答题方式和推广专区设置 ，未设置不能编辑
      projectV2
        .numberQuestionInfoByProject({
          projectId: this.projectId,
          projectType: this.projectType
        })
        .then(() => {
          this.hasAnswerModeAndChannelName = true;
        })
        .catch(() => {
          this.hasAnswerModeAndChannelName = false;
        });
    }
    let { enterprise, numberQuestionChannel: channel } = data;
    channel = channel || {};
    let obj = {
      enterpriseName: (enterprise || {}).enterpriseName,
      channelId: channel.id
    };

    this.defaultObj = {
      title: channel.channelName,
      id: channel.id
    };

    this.ruleForm = {
      ...this.ruleForm,
      ...obj
    };
    this.ruleForm.isNeedCertification = this.homeProject.isNeedCertification;
    this.ruleForm.certificationClassifyList = this.homeProject.certificationClassifyList;
    this.ruleForm.channelEditorType = this.ruleForm.channelEditorType || 2; // 默认为服务商编辑

    this.channel = channel;
    this.addEditMixin_setChannelUrl(channel.id);
    this.$nextTick(() => {
      this.$refs.copyBtn.$el.disabled = !this.addEditMixin_channelWebUrl;
      this.$refs.copyBtn.$el.className = 'el-button copyBtn el-button--success';
    });

    this.$emit('resetRuleForm', this.ruleForm);
  }
};
</script>
<style lang="scss" scoped>
.redText {
  ::v-deep {
    .el-textarea__inner {
      color: red;
    }
  }
}
</style>
